//store/index.ts
import { MobilityProcessRespone } from "@/api/generated/ElectraInterfaces";
import { makeVar } from "@apollo/client";
import { FormState } from "./indes.modal";

type ProcessType = MobilityProcessRespone & {
  selectedPackageName: string | null;
  refId?: string;
  referralCampaignName?: string;
  affiliateId?: string;
};

const formVarInitialState: FormState = {
  firstName: "",
  lastName: "",
  id: "",
  email: "",
  phone: "",
  street: "",
  city: "",
  houseNumber: "",
  apartmentNumber: "",
};

const processVarInitialState: ProcessType = {
  accountNumber: "",
  billingPlan: "",
  canTransforme: false,
  meterNumber: "",
  phoneNumber: "",
  processId: "",
  processStatus: null,
  smartMeter: false,
  selectedPackageName: null,
  refId: "",
  referralCampaignName:"",
  affiliateId: "",
};

export const formVar = makeVar<FormState>(formVarInitialState);

export const proccesVar = makeVar<ProcessType>(processVarInitialState);

export const paymentVar = makeVar({
  url: "",
});

export const endingVar = makeVar({
  title: "",
  detailes: "",
  accounts: "",
  packageChosen: "",
});

export const userVar = makeVar({
  checkedSocial: false,
  progress: 0,
  checkedBundle: false,
  packageChosen: "",
  selectedPlanNameString: "",
  referralCode:"",
  referralTitle:"",
  referralSubTitle:"",
  referralSpecialTerms:"",
  referralCampaignName:"",
  refId: "",
  affiliateId: "",
});

export const layoutVar = makeVar({
  openGeneralError: false,
  hideHeader: false,
});

export const clearFormVar = () => {
  formVar(formVarInitialState);
};

export const clearProcessVar = () => {
  proccesVar(processVarInitialState);
};
export const clearPaymentVar = () => {
  paymentVar({ url: "" });
};
export const clearEndingVar = () => {
  endingVar({ title: "", detailes: "", accounts: "", packageChosen: "" });
};

export const clearUserVar = () => {
  userVar({
    checkedSocial: false,
    progress: 0,
    checkedBundle: false,
    packageChosen: "",
    selectedPlanNameString: "",
    referralCode:"",
    referralSubTitle: "",
    referralTitle: "",
    referralCampaignName: "",
    refId: "",
    referralSpecialTerms: "",
    affiliateId: "",
  });
};

export const showGeneralError = () => {
  layoutVar({ ...layoutVar(), openGeneralError: true });
};
export const hideGeneralError = () => {
  layoutVar({ ...layoutVar(), openGeneralError: false });
};
